import React from "react";

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
    };

    this.textInputRef = React.createRef();
    this.onBlur = this.onBlur.bind(this);
    this.onInput = this.onInput.bind(this);
  }

  componentDidMount() {
    var { cents = true } = this.props;
    var $textInput = $(this.textInputRef.current);

    if (!isNaN(parseInt(this.props.value))) {
      $textInput.val((this.props.value / 100).toFixed(2));
    }

    // bind autoNumeric
    $textInput.autoNumeric({
      aSep: $("#delimiter").val() || ",",
      aDec: $("#separator").val() || ".",
      lZero: "keep",
      mDec: cents ? "2" : "0",
    })
    .on("change", this.onInput)
    .on("input", this.onInput)
    .on("focus", () => {
      this.textInputRef.current.select();
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // This is nessisary to enter a negative amount.
    // Negative amounts are needed for cash payments
    if (this.props.ignoreComponentWillReceiveProps === true) {
      return;
    }

    if (
      (this.state.value !== nextProps.value &&
      typeof nextProps.value != "undefined") || (nextProps.value == 0 && this.state.value == 0)
    ) {
      if (nextProps.value === null || nextProps.value === "" || isNaN(nextProps.value)) {
        this.setState({ value: "" }, () => {
          $(this.textInputRef.current).autoNumeric("wipe");
        });
      } else {
        this.setState({ value: nextProps.value }, () => {
          $(this.textInputRef.current).autoNumeric(
            "set",
            this.state.value / 100
          );
        });
      }
    }
  }

  onBlur(e) {
    if (typeof this.props.onBlur === 'function') {
      this.fireBlur(e);
    }
  }

  onInput() {
    var value = "";
    var inputValue = $(this.textInputRef.current).autoNumeric("get");

    if (!isNaN(inputValue)) {
      if (
        typeof this.props.min != "undefined" &&
        inputValue * 100 < this.props.min
      ) {
        value = inputValue = this.props.min;
        $(this.textInputRef.current).autoNumeric("set", inputValue / 100);
      } else if (
        typeof this.props.max != "undefined" &&
        inputValue * 100 > this.props.max
      ) {
        value = inputValue = this.props.max;
        $(this.textInputRef.current).autoNumeric("set", inputValue / 100);
      } else if (inputValue != 0) {
        value = parseInt(Math.round(inputValue * 100));
      } else if (inputValue == 0) {
        value = null; //parseInt(inputValue);
      } else {
        value = null;
      }
    }

    this.setState({ value: value }, () => {
      if (this.props.onChange) {
        if (this.props.onChangeEventType === true) {
          this.props.onChange({
            target: { value: value, name: this.props.name, id: this.props.id },
          });
        } else {
          this.props.onChange(
            value,
            this.props.additionalValue ? this.props.additionalValue : null
          );
        }
      }
    });
  }

  render() {
    const { className = "", 
            disabled = false, 
            name = "", 
            placeholder = "0.00", 
            style = {}, 
            tabIndex = 0 
          } = this.props;
    return (
      <div className={(className.includes('has-errors') ? 'has-errors' : '') + " input-group CurrencyInput"}>
        <div className="input-group-prepend">
          <span className="input-group-text">
            {I18n.t("number.currency.format.unit")}
          </span>
        </div>
        <input
          type="text"
          ref={this.textInputRef}
          disabled={disabled}
          name={name + "_masked"}
          className={className + " form-control"}
          placeholder={placeholder}
          tabIndex={tabIndex}
          style={style}
          onBlur={this.onBlur}
        />
      </div>
    );
  }

  getValue() {
    return this.state.value || 0;
  }

  fireBlur = (e) => {
    if (this.props.passValue) {
      this.props.onBlur(this.state.value);
    } else if (this.props.onChangeEventType) {
      this.props.onBlur({
        target: {
          value: this.state.value,
          name: this.props.name,
          id: this.props.id,
        },
      });
    } else {
      this.props.onBlur(e);
    }
  };
}

export default CurrencyInput;
